export default function Hero() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center bg-background-50 overflow-hidden">
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary-100/50" />
        <div className="absolute -bottom-20 -left-20 w-[400px] h-[400px] rounded-full bg-accent-100/40" />
        <div className="absolute top-1/3 right-1/4 w-[200px] h-[200px] rounded-full bg-secondary-100/30" />
      </div>

      <div className="relative w-full px-4 md:px-6 pt-[72px]">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <p className="inline-block text-sm font-medium text-primary-600 bg-primary-50 px-4 py-1.5 rounded-full mb-5">
              每日更新 · 万部漫画随心看
            </p>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-foreground-950 leading-tight mb-4">
              UU漫画 - 韩漫日漫国漫
              <br className="hidden sm:block" />
              一站式推荐平台
            </h1>

            <p className="text-lg md:text-xl text-primary-500 font-heading mb-6">
              发现你的下一部心头好
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-5">
              UU漫画专注为漫画爱好者提供韩漫推荐、日漫大全与国漫排行榜等热门漫画类型导航。
              无论你偏爱热血少年、甜蜜恋爱、悬疑推理还是奇幻冒险，
              我们每日精选优质作品并实时更新章节动态，
              帮你告别漫荒，快速锁定下一部值得追的好看漫画。
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-7">
              当前平台已覆盖超过<strong className="text-primary-500">10万+漫画资源</strong>，
              每日稳定更新<strong className="text-primary-500">300+章节</strong>，
              服务可用率高达<strong className="text-primary-500">99.9%</strong>，
              无论何时打开UU漫画，好内容从不缺席。
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#cards"
                className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 px-7 py-3 rounded-md font-medium text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                开始探索
                <i className="ri-arrow-right-line" />
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 border border-background-300 hover:border-primary-300 text-foreground-700 hover:text-primary-500 px-7 py-3 rounded-md font-medium text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                热门榜单
                <i className="ri-fire-line" />
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg aspect-[4/5] rounded-lg overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20colorful%20manga%20and%20comic%20book%20collage%20with%20dynamic%20action%20scenes%2C%20Korean%20manhwa%20style%20characters%2C%20Japanese%20manga%20illustrations%2C%20Chinese%20manhua%20artwork%2C%20warm%20energetic%20color%20palette%20with%20orange%20and%20teal%20accents%2C%20playful%20and%20modern%20composition%2C%20clean%20artistic%20background%2C%20editorial%20design%20layout&width=800&height=1000&seq=hero-comic-visual&orientation=portrait"
                alt="UU漫画 - 韩漫日漫国漫一站式推荐"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/30 via-transparent to-transparent" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}